module.exports = __webpack_public_path__ + "img/tree_mobile-5.b5d255b6.png";